export default __webpack_public_path__ + "static/latitude-scam-alert-1-33085af7e2c17475985d3c969d052aca.webp";